import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authAPI } from '../../utils/api';
import { Alert, Spinner } from '../../components/ui';
import toast from 'react-hot-toast';

const GROUPS = [
  { value:'Group1', icon:'🏛️', name:'Group 1', sub:'Deputy Collector, DSP' },
  { value:'Group2', icon:'📋', name:'Group 2', sub:'Sub Registrar, HR Officer' },
  { value:'Group2A', icon:'📗', name:'Group 2A', sub:'Junior Assistant, Typist' },
  { value:'Group4', icon:'📙', name:'Group 4', sub:'Bill Collector, VAO' },
];

const INIT = { full_name:'',father_mother_name:'',date_of_birth:'',address:'',phone:'',email:'',gender:'',category:'',exam_groups:[],password:'',confirm_password:'' };

const pwStrength = pw => {
  let s = 0;
  if (pw.length >= 8) s++;
  if (/[A-Z]/.test(pw)) s++;
  if (/\d/.test(pw)) s++;
  if (/[^A-Za-z0-9]/.test(pw)) s++;
  return s;
};

export default function Register() {
  const nav = useNavigate();
  const [step, setStep] = useState(1);
  const [form, setForm] = useState(INIT);
  const [errs, setErrs] = useState({});
  const [loading, setLoading] = useState(false);
  const [apiErr, setApiErr] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [showCPw, setShowCPw] = useState(false);

  const f = (k, v) => { setForm(p => ({ ...p, [k]: v })); setErrs(p => ({ ...p, [k]: '' })); };

  const v1 = () => {
    const e = {};
    if (!form.full_name.trim()) e.full_name = 'Full name is required';
    if (!form.father_mother_name.trim()) e.father_mother_name = 'Parent name is required';
    if (!form.date_of_birth) e.date_of_birth = 'Date of birth is required';
    if (!form.gender) e.gender = 'Select gender';
    if (!/^\d{10}$/.test(form.phone)) e.phone = 'Enter valid 10-digit mobile number';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = 'Enter valid email address';
    if (!form.address.trim()) e.address = 'Address is required';
    if (!form.category) e.category = 'Select category';
    setErrs(e); return !Object.keys(e).length;
  };

  const v2 = () => {
    const e = {};
    if (!form.exam_groups || form.exam_groups.length === 0) e.exam_groups = 'Please select at least one exam group';
    if (form.password.length < 8) e.password = 'Minimum 8 characters required';
    if (form.password !== form.confirm_password) e.confirm_password = 'Passwords do not match';
    setErrs(e); return !Object.keys(e).length;
  };

  const submit = async () => {
    setApiErr(''); setLoading(true);
    try {
      const { confirm_password, ...payload } = form;
      const r = await authAPI.register({ ...form, exam_group: form.exam_groups.join(',') });
      toast.success('Registered successfully!');
      nav(`/payment?user_id=${r.data.userId || r.data.user_id}&groups=${encodeURIComponent(form.exam_groups.join(','))}`);
    } catch (err) { setApiErr(err.response?.data?.message || 'Registration failed. Please try again.'); }
    finally { setLoading(false); }
  };

  const str = pwStrength(form.password);
  const strColor = ['#dc3545','#fd7e14','#ffc107','#28a745'][str - 1] || '#e0e0e0';
  const strLabel = ['Weak','Fair','Good','Strong'][str - 1] || '';

  const STEPS_META = [
    { n:1, label:'Personal Info' },
    { n:2, label:'Exam & Password' },
    { n:3, label:'Review & Submit' },
  ];

  return (
    <div style={{ minHeight:'100vh', background:'var(--bg)', fontFamily:'var(--font-body)' }}>
      {/* Top progress bar */}
      <div style={{ position:'fixed', top:0, left:0, right:0, height:3, background:'var(--border)', zIndex:9999 }}>
        <div style={{ height:'100%', width:`${(step/3)*100}%`, background:'linear-gradient(90deg,var(--blue),var(--gold))', transition:'width 0.4s ease', borderRadius:'0 2px 2px 0' }} />
      </div>

      {/* Navbar */}
      <nav style={{ background:'#fff', borderBottom:'1px solid var(--border)', padding:'0 5%', height:62, display:'flex', alignItems:'center', justifyContent:'space-between', position:'sticky', top:0, zIndex:100, boxShadow:'0 2px 8px rgba(26,60,143,0.04)' }}>
        <Link to="/" style={{ fontFamily:'var(--font-heading)', fontSize:20, fontWeight:700, color:'var(--blue)', textDecoration:'none' }}>
          TNPSC <span style={{ color:'var(--gold)' }}>Hub</span>
        </Link>
        <span style={{ fontSize:13, color:'var(--muted)' }}>
          Already registered? <Link to="/login" style={{ color:'var(--blue)', fontWeight:700 }}>Login →</Link>
        </span>
      </nav>

      <div style={{ maxWidth:700, margin:'0 auto', padding:'40px 20px 80px' }}>
        {/* Step indicator */}
        <div style={{ display:'flex', alignItems:'center', marginBottom:40 }}>
          {STEPS_META.map((s, i) => (
            <React.Fragment key={s.n}>
              <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:7, flexShrink:0 }}>
                <div style={{ width:44, height:44, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'var(--font-heading)', fontSize:17, fontWeight:800, transition:'all 0.35s', transform: step === s.n ? 'scale(1.12)' : 'scale(1)', boxShadow: step === s.n ? '0 6px 20px rgba(26,60,143,0.3)' : 'none', background: step > s.n ? 'var(--success)' : step === s.n ? 'var(--blue)' : '#fff', border: `2px solid ${step > s.n ? 'var(--success)' : step === s.n ? 'var(--blue)' : 'var(--border)'}`, color: step >= s.n ? '#fff' : 'var(--muted)' }}>
                  {step > s.n ? '✓' : s.n}
                </div>
                <span style={{ fontSize:10, fontWeight:700, letterSpacing:'0.4px', textTransform:'uppercase', color: step === s.n ? 'var(--blue)' : step > s.n ? 'var(--success)' : 'var(--muted)', whiteSpace:'nowrap' }}>{s.label}</span>
              </div>
              {i < 2 && <div style={{ flex:1, height:2, margin:'0 8px', marginBottom:22, background: step > s.n ? 'var(--success)' : 'var(--border)', transition:'background 0.35s' }} />}
            </React.Fragment>
          ))}
        </div>

        <div className="card" style={{ animation:'scaleIn 0.35s ease' }}>
          <div className="card-body" style={{ padding:32 }}>

            {/* ── STEP 1 ── */}
            {step === 1 && <>
              <h2 style={{ fontFamily:'var(--font-heading)', fontSize:26, marginBottom:6 }}>Personal Information</h2>
              <p style={{ color:'var(--muted)', fontSize:13, marginBottom:28 }}>Please fill all details accurately — they will be used for account verification.</p>
              <div className="g2">
                {[['full_name','Full Name','👤','Your full name as in ID'],['father_mother_name',"Father / Mother Name",'👨‍👩‍👦','As in school certificate']].map(([k,l,ic,ph]) => (
                  <div key={k} className="form-group">
                    <label className="form-label">{l} <span className="req">*</span></label>
                    <div className="input-wrap"><span className="input-icon">{ic}</span>
                      <input className={`form-input${errs[k] ? ' error':''}`} placeholder={ph} value={form[k]} onChange={e => f(k, e.target.value)} />
                    </div>
                    {errs[k] && <span className="field-error">{errs[k]}</span>}
                  </div>
                ))}
                <div className="form-group">
                  <label className="form-label">Date of Birth <span className="req">*</span></label>
                  <div className="input-wrap"><span className="input-icon">📅</span>
                    <input type="date" className={`form-input${errs.date_of_birth ? ' error':''}`} value={form.date_of_birth} onChange={e => f('date_of_birth', e.target.value)} max={new Date().toISOString().split('T')[0]} />
                  </div>
                  {errs.date_of_birth && <span className="field-error">{errs.date_of_birth}</span>}
                </div>
                <div className="form-group">
                  <label className="form-label">Gender <span className="req">*</span></label>
                  <div className="input-wrap"><span className="input-icon">⚥</span>
                    <select className={`form-select${errs.gender ? ' error':''}`} value={form.gender} onChange={e => f('gender', e.target.value)}>
                      <option value="">Select gender</option><option>Male</option><option>Female</option><option>Other</option>
                    </select>
                  </div>
                  {errs.gender && <span className="field-error">{errs.gender}</span>}
                </div>
                <div className="form-group">
                  <label className="form-label">Mobile Number <span className="req">*</span></label>
                  <div className="input-wrap"><span className="input-icon">📱</span>
                    <input className={`form-input${errs.phone ? ' error':''}`} placeholder="10-digit mobile number" maxLength={10} value={form.phone} onChange={e => f('phone', e.target.value.replace(/\D/g,''))} />
                  </div>
                  {errs.phone && <span className="field-error">{errs.phone}</span>}
                </div>
                <div className="form-group">
                  <label className="form-label">Email Address <span className="req">*</span></label>
                  <div className="input-wrap"><span className="input-icon">📧</span>
                    <input type="email" className={`form-input${errs.email ? ' error':''}`} placeholder="your@email.com" value={form.email} onChange={e => f('email', e.target.value)} />
                  </div>
                  {errs.email && <span className="field-error">{errs.email}</span>}
                </div>
                <div className="form-group">
                  <label className="form-label">Category <span className="req">*</span></label>
                  <div className="input-wrap"><span className="input-icon">🏷️</span>
                    <select className={`form-select${errs.category ? ' error':''}`} value={form.category} onChange={e => f('category', e.target.value)}>
                      <option value="">Select category</option><option>OC</option><option>BC</option><option>MBC</option><option>SC</option><option>ST</option>
                    </select>
                  </div>
                  {errs.category && <span className="field-error">{errs.category}</span>}
                </div>
                <div className="form-group" style={{ gridColumn:'1/-1' }}>
                  <label className="form-label">Full Address <span className="req">*</span></label>
                  <textarea className={`form-textarea${errs.address ? ' error':''}`} placeholder="Door No, Street, City, District — Pincode" value={form.address} onChange={e => f('address', e.target.value)} />
                  {errs.address && <span className="field-error">{errs.address}</span>}
                </div>
              </div>
              <div style={{ display:'flex', justifyContent:'flex-end', marginTop:8 }}>
                <button className="btn btn-primary btn-lg" onClick={() => { if (v1()) setStep(2); }}>Next: Exam Group →</button>
              </div>
            </>}

            {/* ── STEP 2 ── */}
            {step === 2 && <>
              <h2 style={{ fontFamily:'var(--font-heading)', fontSize:26, marginBottom:6 }}>Exam Group & Password</h2>
              <p style={{ color:'var(--muted)', fontSize:13, marginBottom:28 }}>Select your target exam and create a secure password.</p>

              <div className="form-group">
                <label className="form-label">Select Exam Group(s) <span className="req">*</span> <span style={{fontWeight:400,color:'var(--muted)',fontSize:11}}>— select one or more</span></label>
                <div style={{ background:'rgba(245,166,35,0.08)', border:'1px solid rgba(245,166,35,0.3)', borderRadius:9, padding:'8px 12px', marginBottom:10, fontSize:12, color:'#7a5200' }}>
                  ✅ You can select <strong>multiple groups</strong>. One payment of ₹499 covers all selected groups.
                </div>
                <div style={{ display:'grid', gridTemplateColumns:'repeat(2,1fr)', gap:12, marginTop:8 }}>
                  {GROUPS.map(g => (
                    <div key={g.value} onClick={() => { const sel = form.exam_groups.includes(g.value); f('exam_groups', sel ? form.exam_groups.filter(x=>x!==g.value) : [...form.exam_groups, g.value]); }} style={{ border:`2px solid ${form.exam_groups.includes(g.value) ? 'var(--blue)' : 'var(--border)'}`, borderRadius:14, padding:'18px 16px', cursor:'pointer', transition:'all 0.25s', background: form.exam_groups.includes(g.value) ? 'rgba(26,60,143,0.04)' : '#fafbff', display:'flex', alignItems:'center', gap:13 }}>
                      <div style={{ width:46, height:46, borderRadius:12, background: form.exam_groups.includes(g.value) ? 'rgba(26,60,143,0.1)' : 'var(--bg)', border:`1.5px solid ${form.exam_groups.includes(g.value) ? 'rgba(26,60,143,0.22)' : 'var(--border)'}`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:22, flexShrink:0 }}>{g.icon}</div>
                      <div>
                        <div style={{ fontSize:14, fontWeight:700, color: form.exam_groups.includes(g.value) ? 'var(--blue)' : 'var(--dark)' }}>{g.name}</div>
                        <div style={{ fontSize:11, color:'var(--muted)', marginTop:2 }}>{g.sub}</div>
                      </div>
                      {form.exam_groups.includes(g.value) && <span style={{ marginLeft:'auto', fontSize:16 }}>✅</span>}
                    </div>
                  ))}
                </div>
                {errs.exam_groups && <span className="field-error" style={{ marginTop:8 }}>{errs.exam_groups}</span>}
              </div>

              <div className="g2" style={{ marginTop:24 }}>
                <div className="form-group">
                  <label className="form-label">Password <span className="req">*</span></label>
                  <div className="input-wrap">
                    <span className="input-icon">🔒</span>
                    <input type={showPw ? 'text' : 'password'} className={`form-input${errs.password ? ' error':''}`} placeholder="Minimum 8 characters" value={form.password} onChange={e => f('password', e.target.value)} style={{ paddingRight:44 }} />
                    <button type="button" onClick={() => setShowPw(s=>!s)} style={{ position:'absolute',right:12,top:'50%',transform:'translateY(-50%)',background:'none',border:'none',cursor:'pointer',fontSize:15,color:'#bbb' }}>{showPw ? '🙈':'👁️'}</button>
                  </div>
                  {errs.password && <span className="field-error">{errs.password}</span>}
                  {form.password && (
                    <div style={{ marginTop:8 }}>
                      <div style={{ display:'flex', gap:4 }}>
                        {[1,2,3,4].map(i => <div key={i} style={{ flex:1, height:4, borderRadius:2, background: i <= str ? strColor : 'var(--border)', transition:'background 0.3s' }} />)}
                      </div>
                      <span style={{ fontSize:11, fontWeight:700, color:strColor }}>{strLabel}</span>
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <label className="form-label">Confirm Password <span className="req">*</span></label>
                  <div className="input-wrap">
                    <span className="input-icon">🔒</span>
                    <input type={showCPw ? 'text' : 'password'} className={`form-input${errs.confirm_password ? ' error':''}`} placeholder="Re-enter password" value={form.confirm_password} onChange={e => f('confirm_password', e.target.value)} style={{ paddingRight:44 }} />
                    <button type="button" onClick={() => setShowCPw(s=>!s)} style={{ position:'absolute',right:12,top:'50%',transform:'translateY(-50%)',background:'none',border:'none',cursor:'pointer',fontSize:15,color:'#bbb' }}>{showCPw ? '🙈':'👁️'}</button>
                  </div>
                  {errs.confirm_password && <span className="field-error">{errs.confirm_password}</span>}
                  {form.confirm_password && !errs.confirm_password && form.password === form.confirm_password && <span style={{ fontSize:11, color:'var(--success)', fontWeight:600 }}>✅ Passwords match</span>}
                </div>
              </div>

              <div style={{ display:'flex', justifyContent:'space-between', marginTop:24 }}>
                <button className="btn btn-outline btn-lg" onClick={() => setStep(1)}>← Back</button>
                <button className="btn btn-primary btn-lg" onClick={() => { if (v2()) setStep(3); }}>Next: Review →</button>
              </div>
            </>}

            {/* ── STEP 3 ── */}
            {step === 3 && <>
              <h2 style={{ fontFamily:'var(--font-heading)', fontSize:26, marginBottom:6 }}>Review & Submit</h2>
              <p style={{ color:'var(--muted)', fontSize:13, marginBottom:24 }}>Please verify all details before submitting.</p>

              <div style={{ background:'var(--bg)', borderRadius:14, overflow:'hidden', border:'1px solid var(--border)', marginBottom:20 }}>
                {[['👤 Full Name', form.full_name],['👨‍👩‍👦 Parent Name', form.father_mother_name],['📅 Date of Birth', form.date_of_birth],['⚥ Gender', form.gender],['📱 Mobile', form.phone],['📧 Email', form.email],['🏷️ Category', form.category],['🎯 Exam Groups', form.exam_groups.join(', ')]].map(([l,v]) => (
                  <div key={l} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'12px 18px', borderBottom:'1px solid var(--border)', fontSize:13 }}>
                    <span style={{ color:'var(--muted)', fontWeight:600 }}>{l}</span>
                    <span style={{ color:'var(--dark)', fontWeight:600, maxWidth:'58%', textAlign:'right' }}>{v}</span>
                  </div>
                ))}
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'12px 18px', fontSize:13 }}>
                  <span style={{ color:'var(--muted)', fontWeight:600 }}>🏠 Address</span>
                  <span style={{ color:'var(--dark)', maxWidth:'60%', textAlign:'right', lineHeight:1.5 }}>{form.address}</span>
                </div>
              </div>

              <div style={{ display:'flex', alignItems:'flex-start', gap:9, background:'rgba(26,60,143,0.04)', border:'1px solid rgba(26,60,143,0.12)', borderRadius:10, padding:'12px 14px', marginBottom:20, fontSize:12, color:'var(--blue)' }}>
                <span>ℹ️</span>
                <span>After registration, you'll be redirected to make a ₹499 payment via UPI. Account activates within 24 hours of payment verification.</span>
              </div>

              {apiErr && <Alert type="error" onClose={() => setApiErr('')}>{apiErr}</Alert>}

              <div style={{ display:'flex', justifyContent:'space-between' }}>
                <button className="btn btn-outline btn-lg" onClick={() => setStep(2)}>← Back</button>
                <button className="btn btn-gold btn-lg" onClick={submit} disabled={loading}>
                  {loading ? <><Spinner size={17} color="white" /> Submitting...</> : '✅ Submit Registration'}
                </button>
              </div>
            </>}

          </div>
        </div>
      </div>
      <style>{`@keyframes scaleIn{from{opacity:0;transform:scale(0.96)}to{opacity:1;transform:scale(1)}}`}</style>
    </div>
  );
}
